import { RefObject } from 'react'

export const getElement = <T extends object>(
  element?: RefObject<Element> | Element | null | T
): Element | null | undefined | T =>
  element && 'current' in element ? element?.current : element
